var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7109 3.32087L9.88599 0.470187C9.58552 0.166969 9.19224 0 8.77862 0H3.40039C2.5119 0 1.78906 0.771031 1.78906 1.71875V14.2812C1.78906 15.229 2.5119 16 3.40039 16H11.6035C12.492 16 13.2148 15.229 13.2148 14.2812V4.56944C13.2148 4.09916 13.0312 3.64406 12.7109 3.32087ZM11.8573 3.75H9.66992C9.58915 3.75 9.52344 3.67991 9.52344 3.59375V1.39488L11.8573 3.75ZM11.6035 15.0625H3.40039C2.99653 15.0625 2.66797 14.712 2.66797 14.2812V1.71875C2.66797 1.28797 2.99653 0.9375 3.40039 0.9375H8.64453V3.59375C8.64453 4.19684 9.10452 4.6875 9.66992 4.6875H12.3359V14.2812C12.3359 14.712 12.0074 15.0625 11.6035 15.0625Z",
    fill: "#183243"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSvg);
export default __webpack_public_path__ + "static/media/file_svg.2920d8ddaab9c6d4d8276ba1a043124b.svg";
export { ForwardRef as ReactComponent };